var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('action-button',{attrs:{"icon":_vm.icon,"label":_vm.label,"color":_vm.color,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }